import { getTranslationFromJson } from '@patrianna/shared-utils/prismic'

import ButtonLink from 'components/ButtonLink'
import Page from 'components/Page'
import ROUTES from 'config/routes.json'
import content from 'prismic-translates/page-not-available.json'

import classes from './styles.module.scss'

const t = getTranslationFromJson([content])

type Props = {
  classNameRoot?: string
  classNameContent?: string
}

function PageNotAvailable(props: Props) {
  return (
    <Page
      rootClassName={props.classNameRoot || classes.classNameRoot}
      className={props.classNameContent || classes.classNameContent}
    >
      <div className={classes.root}>
        <div className={classes.content}>
          <h4 className={classes.title}>{t('title')}</h4>

          <ButtonLink variant='contained' href={ROUTES.HOME}>
            {t('go_home_btn')}
          </ButtonLink>
        </div>
      </div>
    </Page>
  )
}

export default PageNotAvailable
